import { render, staticRenderFns } from "./Pregnant.vue?vue&type=template&id=61dded10&"
import script from "./Pregnant.vue?vue&type=script&lang=js&"
export * from "./Pregnant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports